import { NgModule } from '@angular/core';
import { NavModule } from '../nav-menu/nav.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { BasicsModule } from '../basics/basics.module';
import { UserProfileBasicInfoComponent } from './user-profile-basic-info/user-profile-basic-info.component';
import { UserProfileChangePasswordComponent } from './user-profile-change-password/user-profile-change-password.component';
import { UserProfileHeaderComponent } from './user-profile-header/user-profile-header.component';
import { UserProfileComponent } from './user-profile.component';

@NgModule({
  declarations: [
    UserProfileComponent,
    UserProfileBasicInfoComponent,
    UserProfileChangePasswordComponent,
    UserProfileHeaderComponent
  ],
  imports: [
    NavModule,
    CommonModule,
    FormsModule,
    CoreModule,
    BasicsModule
  ]
})

export class UserProfileModule {
}
